<template>
  <span>{{ getDifference() }}</span>
</template>

<script>
  const milisecondsInHour = 1000 * 60 * 60;
  const milisecondsInMinute = 1000 * 60;

  export default {
    props: [
      'createdAt',
      'finishedAt'
    ],
    methods: {
      getDifference() {
        if (this.createdAt && this.finishedAt) {
          const difference = this.finishedAt - this.createdAt;
          const hours = Math.floor(difference / milisecondsInHour);
          const minutes = Math.floor((difference - (hours * milisecondsInHour)) / milisecondsInMinute);

          return `${hours}h ${minutes}m`;
        }

        if (this.createdAt) {
          const difference = new Date() - this.createdAt;
          const hours = Math.floor(difference / milisecondsInHour);
          const minutes = Math.floor((difference - (hours * milisecondsInHour)) / milisecondsInMinute);

          return `${hours}h ${minutes}m`;
        }

        return '-';
      }
    }
  }
</script>
